import React from 'react';

interface FormatsTabProps {
    isOpen: boolean;
    toggle: () => void;
    handleForm: any;
}

const AdpFormatsConfigModal: React.FC<FormatsTabProps> = ({ isOpen, toggle, handleForm }) => {
    const updateGlobalConfig = (field: string, value: any) => {
        handleForm.setFieldValue(field, value);
    };

    return (
        <div className={`modal ${isOpen ? 'show d-block' : ''}`} tabIndex={-1} role="dialog">
            <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">⚙️ Configurações Globais da Tag</h5>
                        <button type="button" className="btn-close" onClick={toggle} aria-label="Close"></button>
                    </div>

                    <div className="modal-body">
                <p className="text-muted mb-4">
                    Configurações que se aplicam a todos os formatos ADP desta tag.
                    Essas configurações são aplicadas globalmente e raramente precisam ser alteradas.
                </p>

                <div className="row">
                    <div className="col-12">
                        <div className="form-group">
                            <label htmlFor="modal-minAdSpace" className="form-label">
                                📏 Espaçamento Mínimo Entre Anúncios
                            </label>
                            <p className="text-muted small mb-2">
                                Define a distância mínima entre formatos que se repetem na mesma página.
                                Isso evita que os anúncios fiquem muito próximos uns dos outros, melhorando a experiência do usuário.
                            </p>
                            <input
                                id="modal-minAdSpace"
                                name="modal-minAdSpace"
                                type="text"
                                className="form-control"
                                placeholder="Ex: 200px, 0.5vh, 1rem"
                                value={handleForm.values.minAdSpace || ''}
                                onChange={(e) => updateGlobalConfig('minAdSpace', e.target.value)}
                            />
                            <div className="form-text">
                                💡 Use unidades CSS como px (pixels), vh (altura da viewport), vw (largura da viewport), rem, em
                            </div>
                        </div>
                    </div>
                </div>
                    </div>

                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={toggle}>
                            Fechar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdpFormatsConfigModal;